import { render, staticRenderFns } from "./CloseHolder.vue?vue&type=template&id=6fa5566d&"
import script from "./CloseHolder.vue?vue&type=script&lang=js&"
export * from "./CloseHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports